import axios from 'axios';
import { ISocialVideoResponse } from 'types/services';
import { Apis } from 'constants/apis';
import { getToken } from 'utils/token';

const allSocialVideos = async (): Promise<ISocialVideoResponse[]> => {
    const { data } = await axios.get(`${Apis.GET_SOCIAL_VIDEOS}`, { headers: { Authorization: getToken() } });
    return data;
};

export default allSocialVideos;
